var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { castFunction, compact, size } from '@ally/utilitarian';
import { defaultAPIError } from '../constants';
/**
 * Functional wrapper that, given a function `f` will return a function that
 * only executes `f` if the given input isn't "nil" (null or undefined). If the
 * given input is nil, `null` is return and the invocation of `f` is skipped.
 */
export function maybe(f) {
    return function (x) { return (x == null ? null : f(x)); };
}
export function fail(getError) {
    return function (data) {
        throw new Error(getError(data) || defaultAPIError);
    };
}
export function failWhenErrorOnly(getError) {
    return function (data) {
        return data && size(data) === 1 && getError(data)
            ? fail(getError)(data)
            : data;
    };
}
export function getHeadersObject(headers) {
    if (Array.isArray(headers))
        return Object.fromEntries(headers);
    if (headers instanceof Headers) {
        var headerObject_1 = {};
        headers.forEach(function (value, key) { return (headerObject_1[key] = value); });
        return headerObject_1;
    }
    return headers;
}
export function getHeaderEntries(headers) {
    return Object.entries(getHeadersObject(headers));
}
export function getSanitizedHeaders(headers) {
    var pairs = getHeaderEntries(headers);
    var clean = pairs.map(function (_a) {
        var _b = __read(_a, 2), k = _b[0], v = _b[1];
        return (v ? [k, v.toString()] : null);
    });
    return Object.fromEntries(compact(clean));
}
export function mergeHeaders() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args
        .map(function (arg) { return getHeadersObject(new Headers(arg)); })
        .reduce(function (a, b) { return (__assign(__assign({}, a), b)); }, {});
}
export function withDefaultHeaders(headers) {
    return function (init) {
        var _a;
        return __assign(__assign({}, init), { headers: mergeHeaders(castFunction(headers)(init), (_a = init.headers) !== null && _a !== void 0 ? _a : {}) });
    };
}
/**
 * Returns the content type when one doesn't exist for the appropriate methods.
 * If a user supplied one, it will take precedence and be returned.
 */
export function getContentType(_a, fallback) {
    var _b = _a === void 0 ? {} : _a, _c = _b.method, method = _c === void 0 ? 'GET' : _c, headers = _b.headers;
    if (fallback === void 0) { fallback = 'application/json'; }
    var contentType = new Headers(headers).get('Content-Type');
    return ['PUT', 'POST', 'PATCH'].includes(method)
        ? contentType !== null && contentType !== void 0 ? contentType : fallback : undefined;
}
//# sourceMappingURL=general.js.map